import { Avatar } from "@mui/material";
import React from "react";
import "./Suggestions.css";

function Suggestions() {
  return (
    <div className="suggestions">
      <div className="suggestions__title">اقتراحات لك</div>
      <div className="suggestions__usernames">
        <div className="suggestions__username">
          <div className="username__left">
            <span className="avatar">
              <Avatar>R</Avatar>
            </span>
            <div className="username__info">
              <span className="username">Amal_</span>
              <span className="relation"> جديد على إنستجرام </span>
            </div>
          </div>
          <button className="follow__button">متابعه</button>
        </div>

        <div className="suggestions__username">
          <div className="username__left">
            <span className="avatar">
              <Avatar>R</Avatar>
            </span>
            <div className="username__info">
              <span className="username">Fahad</span>
              <span className="relation">جديد على إنستجرام </span>
            </div>
          </div>
          <button className="follow__button">متابعه</button>
        </div>

        <div className="suggestions__username">
          <div className="username__left">
            <span className="avatar">
              <Avatar>R</Avatar>
            </span>
            <div className="username__info">
              <span className="username">Amwaj</span>
              <span className="relation">جديد على إنستجرام </span>
            </div>
          </div>
          <button className="follow__button">متابعه</button>
        </div>

        <div className="suggestions__username">
          <div className="username__left">
            <span className="avatar">
              <Avatar>R</Avatar>
            </span>
            <div className="username__info">
              <span className="username">Sattam</span>
              <span className="relation">جديد على إنستجرام </span>
            </div>
          </div>
          <button className="follow__button">متابعه</button>
        </div>
      </div>
    </div>
  );
}

export default Suggestions;
